import {Plugin} from 'prosemirror-state';
import {chainCommands, deleteSelection, toggleMark, wrapIn,} from 'prosemirror-commands';
import {liftListItem, sinkListItem} from 'prosemirror-schema-list';
import {
    addColumnAfter,
    addColumnBefore,
    addRowAfter,
    addRowBefore,
    CellSelection,
    deleteColumn,
    deleteRow,
    deleteTable,
    mergeCells,
    setCellAttr,
    splitCell,
    toggleHeaderColumn,
    toggleHeaderRow,
} from 'prosemirror-tables';
import {toggleBlockType, toggleList} from './commands';
import {
    findColumn,
    findLink,
    findRelativeTime,
    isImage,
    isInBulletOrOrderedList,
    isInCard,
    isInCardContent,
    isInCardHeading,
    isInCheckList,
    isInFormLabel,
    isInGridColumn,
    isInHeading,
    isInList,
    isInPageTitle,
    isLink,
    isNodeTypesSelected,
    isText,
} from '../helper/nodeSelection';
import {mediaSizeFit} from '../helper/file';
import isEmpty from 'lodash/isEmpty';
import {colors} from '../helper/colors';

import ArrowExpandAllSvg from '@mdi/svg/svg/arrow-expand-all.svg';
import CodeTagsSvg from '@mdi/svg/svg/code-tags.svg';
import CalendarClockOutlinesSvg from '@mdi/svg/svg/calendar-clock-outline.svg';
import CommentQuoteOutlineSvg from '@mdi/svg/svg/comment-quote-outline.svg';
import FormatAlignCenterSvg from '@mdi/svg/svg/format-align-center.svg';
import FormatAlignLeftSvg from '@mdi/svg/svg/format-align-left.svg';
import FormatAlignRightSvg from '@mdi/svg/svg/format-align-right.svg';
import FormatBoldSvg from '@mdi/svg/svg/format-bold.svg';
import FormatColorFillSvg from '@mdi/svg/svg/format-color-fill.svg';
import FormatColorHighlightSvg from '@mdi/svg/svg/format-color-highlight.svg';
import FormatHeader1Svg from '@mdi/svg/svg/format-header-1.svg';
import FormatHeader2Svg from '@mdi/svg/svg/format-header-2.svg';
import FormatHeader3Svg from '@mdi/svg/svg/format-header-3.svg';
import FormatIndentDecreaseSvg from '@mdi/svg/svg/format-indent-decrease.svg';
import FormatIndentIncreaseSvg from '@mdi/svg/svg/format-indent-increase.svg';
import FormatItalicSvg from '@mdi/svg/svg/format-italic.svg';
import FormatListBulletedSvg from '@mdi/svg/svg/format-list-bulleted.svg';
import FormatListChecksSvg from '@mdi/svg/svg/format-list-checks.svg';
import FormatListNumberedSvg from '@mdi/svg/svg/format-list-numbered.svg';
import FormatStrikethroughSvg from '@mdi/svg/svg/format-strikethrough.svg';
import FormatUnderlineSvg from '@mdi/svg/svg/format-underline.svg';
import LabelSvg from '@mdi/svg/svg/label.svg';
import LinkSvg from '@mdi/svg/svg/link.svg';
import SizeLSvg from '@mdi/svg/svg/size-l.svg';
import SizeMSvg from '@mdi/svg/svg/size-m.svg';
import SizeSSvg from '@mdi/svg/svg/size-s.svg';
import ImageEditOutlineSvg from '@mdi/svg/svg/image-edit-outline.svg';
import SquareRootSvg from '@mdi/svg/svg/square-root.svg';
import TableColumnSvg from '@mdi/svg/svg/table-column.svg';
import TableColumnPlusAfterSvg from '@mdi/svg/svg/table-column-plus-after.svg';
import TableColumnPlusBeforeSvg from '@mdi/svg/svg/table-column-plus-before.svg';
import TableColumnRemoveSvg from '@mdi/svg/svg/table-column-remove.svg';
import TableMergeCellsSvg from '@mdi/svg/svg/table-merge-cells.svg';
import TableRemoveSvg from '@mdi/svg/svg/table-remove.svg';
import TableRowSvg from '@mdi/svg/svg/table-row.svg';
import TableRowPlusAfterSvg from '@mdi/svg/svg/table-row-plus-after.svg';
import TableRowPlusBeforeSvg from '@mdi/svg/svg/table-row-plus-before.svg';
import TableRowRemoveSvg from '@mdi/svg/svg/table-row-remove.svg';
import TableSplitCellSvg from '@mdi/svg/svg/table-split-cell.svg';
import DatabaseSvg from '@mdi/svg/svg/database-cog.svg';
import {findTable, getColumnIndex, getRowIndex, isCellSelection, isInTableSelection,} from '../helper/table';

import 'fomantic-ui-less/definitions/modules/calendar.less';

import 'fomantic-ui-less/definitions/behaviors/api';
import 'fomantic-ui-less/definitions/modules/calendar';
import {api} from '../../Common/fetchWithTimeout';
import {moveCursorToEnd} from '../helper/dom';
import {DiagramEditor} from '../helper/DiagramEditor';
import {decode, encode} from 'html-entities';
import {parseJSON, stringifyJSON} from '../../Common/json';
import isEqual from 'lodash/isEqual';
import {createRelativeTime} from "../../Common/createRelativeTime";

const colorLabels = selected => colors.map(color => `<a class="ui ${color} empty circular label${color === selected ? ' selected' : ''}" data-color="${color}"></a>`);

const isTaskList = node => node?.attrs?.id && node?.attrs.tasks;

const updateImageNodeSize = (view, width, height) => {
    view.focus();
    const state = view.state;
    const transaction = state.tr.setNodeMarkup(state.selection.from, undefined, {
        ...state.selection.node.attrs,
        width,
        height
    });
    view.dispatch(transaction);
}

const showLinkMenu = view => {
    $('#menu_label_color, #menu_table_task_list').popup('destroy');
    const state = view.state;
    const {from} = state.selection;
    const nodeAfter = state.doc.resolve(from).nodeAfter;
    const linkMark = nodeAfter.marks.find(mark => mark.type === state.schema.marks.link);
    let linkValue = '';
    let linkButton = false;
    if (linkMark) {
        linkValue = linkMark.attrs.href;
        linkButton = linkMark.attrs.button;
    }

    $('#menu_link').popup({
        html: `<div id="link-form-${from}" class="ui form">
                  <div class="field required">
                    <div id="link-url-${from}" class="ui tiny search active focus scrolling fluid long">
                        <div class="ui input large">
                          <input id="link-url-${from}-input" name="link-url-${from}-input" class="prompt" type="text" value="${linkValue}" placeholder="Enter link URL or search pages">
                        </div>
                        <div class="results"></div>
                    </div>
                  </div>
                  ${!isImage(view.state) ?
            `<div class="field">
                    <div class="ui checkbox">
                        <input id="link-url-${from}-button" name="link-url-${from}-button" type="checkbox"${linkButton ? ' checked=""' : ''}>
                        <label for="link-url-${from}-button">Display as button</label>
                    </div>
                  </div>` : ''}
                  <div class="ui wrapping spaced buttons">
                    <button id="ok-link-url-${from}" class="ui tiny compact button primary">Ok</button>
                    <button id="open-link-url-${from}" class="ui tiny compact button${isEmpty(linkValue) ? ' disabled' : ''}">Open</button>
                    <button id="cancel-link-url-${from}" class="ui tiny compact button">Cancel</button>
                    <button id="remove-link-url-${from}" class="ui tiny compact button">Remove</button>
                  </div>
              </div>`,
        on: 'manual',
        position: 'bottom center',
        forcePosition: true,
        variation: 'fixed very wide',
        transition: 'scale',
        duration: 0,
        closable: false,
        onVisible: () => {
            moveCursorToEnd(document.querySelector(`#link-url-${from}-input`));

            const $search = $(document.getElementById(`link-url-${from}`)).search({
                transition: 'scale',
                duration: 0,
                showNoResults: false,
                minCharacters: 0,
                apiSettings: {
                    url: '/api/search/pages?query={query}',
                    onResponse: searchResponse => {
                        const results = searchResponse.content.map(page => ({
                            title: isEmpty(page.title) ? 'Untitled' : page.title,
                            description: isEmpty(page.snippetHtml) ? '' : page.snippetHtml,
                            value: `/pages/${page.id}`
                        }));

                        return {results};
                    },
                },
                onSearchQuery: function (value) {
                    const openLink = document.getElementById(`open-link-url-${from}`);
                    if (isEmpty(value)) {
                        openLink.classList.add('disabled');
                    } else {
                        openLink.classList.remove('disabled');
                    }
                },
                onSelect: result => $search.search('set value', result.value),
            });

            document.getElementById(`open-link-url-${from}`).addEventListener("click", e => {
                e.preventDefault();
                window.open($search.search('get value'), '_blank');
            });

            const $form = $(document.getElementById(`link-form-${from}`)).form({
                inline: true,
                autoCheckRequired: true,
                duration: 0,
                fields: {
                    [`link-url-${from}-input`]: 'empty'
                }
            });
            document.getElementById(`ok-link-url-${from}`).addEventListener("click", () => {
                $form.form('validate form');
                if (!$form.form('is valid')) {
                    return;
                }

                const attrs = linkMark ? linkMark.attrs : {};
                const state = view.state;
                const {from, to} = state.selection;
                view.dispatch(state.tr.addMark(from, to, state.schema.marks.link.create({
                    ...attrs,
                    href: $form.form('get value', `link-url-${from}-input`),
                    button: $form.form('get value', `link-url-${from}-button`) !== false
                })).removeMark(from, to, view.state.schema.marks.label));
                view.focus();
            });

            const recreateMenu = value => {
                const el = document.getElementById('menu_link');
                if (el) {
                    $(el).popup('destroy');
                    addTooltip(el, 'Insert link');
                    if (isEmpty(value)) {
                        el.classList.remove('active');
                    } else {
                        el.classList.add('active');
                    }
                }
            }

            document.getElementById(`cancel-link-url-${from}`).addEventListener("click", () => {
                recreateMenu(linkValue);
                view.focus();
            });

            document.getElementById(`remove-link-url-${from}`).addEventListener("click", () => {
                const state = view.state;
                const {from, to} = state.selection;
                view.dispatch(state.tr.removeMark(from, to, state.schema.marks.link));
                recreateMenu(null);
                view.focus();
            });
        },
    }).popup('show');
}

const showRelativeTimeMenu = view => {
    $('#menu_label_color, #menu_table_task_list, #menu_link').popup('destroy');
    const state = view.state;
    const {from, to} = state.selection;
    const datetimeText = view.state.doc.cut(from, to).textContent;
    const nodeAfter = state.doc.resolve(from).nodeAfter;
    const relativeTimeMark = nodeAfter.marks.find(mark => mark.type === state.schema.marks.relative_time);
    $('#menu_relative_time').popup({
        html: `<div id="relative_time-form-${from}" class="ui form">
                  <div class="field required">
                    <label for="relativeTimeFormat-${from}">Format</label>
                    <select id="relativeTimeFormat-${from}" name="relativeTimeFormat-${from}" class="ui fluid search selection dropdown">
                      <option value="relative">Relative</option>
                      <option value="datetime">Datetime</option>
                      <option value="date">Date</option>
                      <option value="duration">Duration</option>
                    </select>
                  </div>
                  ${!(datetimeText?.startsWith('${') && datetimeText?.endsWith('}')) ? `
                  <div class="field">
                    <div class="ui calendar" id="inline_calendar"></div>
                  </div>
                  ` : ''}
                  <div class="ui wrapping spaced buttons">
                    <button id="ok-relative_time-${from}" class="ui tiny compact button primary">Ok</button>
                    <button id="cancel-relative_time-${from}" class="ui tiny compact button">Cancel</button>
                    <button id="remove-relative_time-${from}" class="ui tiny compact button">Remove</button>
                  </div>
              </div>`,
        on: 'manual',
        position: 'bottom center',
        forcePosition: true,
        transition: 'scale',
        duration: 0,
        closable: false,
        onVisible: () => {
            const $form = $(document.getElementById(`relative_time-form-${from}`)).form({
                inline: true,
                autoCheckRequired: true,
                duration: 0,
                fields: {
                    [`relativeTimeFormat-${from}`]: 'empty',
                }
            })
                .form('set value', `relativeTimeFormat-${from}`, relativeTimeMark?.attrs.format === 'datetime' && relativeTimeMark?.attrs.hour !== '2-digit' ? 'date' : relativeTimeMark?.attrs.format);

            const inlineCalender = document.getElementById('inline_calendar');
            inlineCalender && $(inlineCalender)?.calendar({
                today: true,
                constantHeight: true,
                initialDate: relativeTimeMark?.attrs.datetime || datetimeText
            });

            document.getElementById(`ok-relative_time-${from}`).addEventListener("click", () => {
                $form.form('validate form');
                if (!$form.form('is valid')) {
                    return;
                }

                const state = view.state;
                const {from, to} = state.selection;

                const datetime = inlineCalender ? $(inlineCalender)?.calendar('get date')?.toISOString() : datetimeText;
                const attrs = relativeTimeMark ? relativeTimeMark.attrs : {};
                const settings = {
                    ...attrs,
                    datetime
                }

                let format = $form.form('get value', `relativeTimeFormat-${from}`);
                if (format === 'datetime') {
                    settings.hour = '2-digit';
                    settings.minute = '2-digit';
                    settings.second = '2-digit';
                } else {
                    if (format === 'date') {
                        format = 'datetime';
                    }
                    settings.hour = undefined;
                    settings.minute = undefined;
                    settings.second = undefined;
                }
                settings.format = format;

                createRelativeTime(settings).then(relativeTimeText => {
                    view.dispatch(state.tr
                        .addMark(from, to, state.schema.marks.relative_time.create(settings))
                        .insertText(relativeTimeText, from, to).scrollIntoView()
                    );
                    view.focus();
                });
            });

            const recreateMenu = value => {
                const el = document.getElementById('menu_relative_time');
                if (el) {
                    $(el).popup('destroy');
                    addTooltip(el, 'Relative time for ISO 8601 timestamp');
                    if (isEmpty(value)) {
                        el.classList.remove('active');
                    } else {
                        el.classList.add('active');
                    }
                }
            }

            document.getElementById(`cancel-relative_time-${from}`).addEventListener("click", () => {
                recreateMenu(view);
                view.focus();
            });

            document.getElementById(`remove-relative_time-${from}`).addEventListener("click", () => {
                const state = view.state;
                const {from, to} = state.selection;
                const datetime = relativeTimeMark?.attrs.datetime;
                view.dispatch(state.tr.removeMark(from, to, state.schema.marks.relative_time).insertText(datetime, from, to));
                recreateMenu(view);
                view.focus();
            });
        },
    }).popup('show');
}

const closeMenuToolTip = () => {
    document.getElementById('menu-tooltip')?.remove();
    $('.ui.popup').popup('destroy');
}

const setWorkflowDefinitionDropdown = workflowDefinitionId => {
    if (isEmpty(workflowDefinitionId)) {
        return;
    }

    api('/api/workflow-definitions?size=1000', {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
    }).then(({content: workflowDefinitions}) => {
        $(document.getElementById('workflowDefinitionId')).dropdown('setup menu', {
            values: workflowDefinitions.map(workflowDefinition => ({
                value: workflowDefinition.id,
                name: workflowDefinition.name,
            })),
        }).dropdown('set selected', workflowDefinitionId, true);
    });
};

const refreshWorkflowTaskNamesDropdown = (workflowDefinitionId, workflowDefinitionVersion, taskNames) => {
    if (isEmpty(workflowDefinitionId)) {
        return;
    }

    const $dropdown = $(document.getElementById('workflowDefinitionTaskNames')).dropdown('clear').dropdown(
        {
            direction: 'downward',
            apiSettings: {
                url: `/api/workflow-definitions/${workflowDefinitionId}/task-names${isEmpty(workflowDefinitionVersion) ? '' : `?version=${workflowDefinitionVersion}`}`,
                cache: false,
                rawResponse: true,
                onResponse: taskNames => ({
                    success: true,
                    results: taskNames.map(taskName => ({
                        value: encode(taskName),
                        name: encode(taskName),
                    })),
                }),
            },
            filterRemoteData: true,
            saveRemoteData: false,
            duration: 0,
        }
    );

    if (!isEmpty(taskNames)) {
        $dropdown.dropdown('set selected', taskNames);
    }
}

const refreshWorkflowDefinitionVersionsDropdown = (workflowDefinitionId, version) => {
    if (isEmpty(workflowDefinitionId)) {
        return;
    }

    const $dropdown = $(document.getElementById('workflowDefinitionVersion')).dropdown('clear').dropdown(
        {
            direction: 'downward',
            apiSettings: {
                url: `/api/workflow-definitions/${workflowDefinitionId}/versions`,
                cache: false,
                rawResponse: true,
                onResponse: summaryList => ({
                    success: true,
                    results: summaryList.map(summary => ({
                        value: summary.version,
                        name: `Version ${summary.version}`,
                    })),
                }),
            },
            onChange: version => {
                refreshWorkflowTaskNamesDropdown(workflowDefinitionId, version);
            },
            filterRemoteData: true,
            saveRemoteData: false,
            duration: 0,
        }
    );

    if (!isEmpty(version)) {
        $dropdown.dropdown('set selected', version, true);
    }
}

const showTaskListMenu = view => {
    $('#menu_link, #menu_label_color').popup('destroy');
    const state = view.state;
    const tableNode = findTable(state.selection) || findColumn(state);
    const size = Number(tableNode.node.attrs.size || 10);

    $('#menu_table_task_list').popup({
        html: `<div id="workflow-form-${tableNode.pos}" class="ui form">
            <div class="field required">
                <label for="workflowDefinitionId">Workflow definition</label>
                <select id="workflowDefinitionId" name="workflowDefinitionId" class="ui fluid search selection dropdown">
                  <option value="">Select workflow definition</option>
                </select>
            </div>
            <div class="field">
                <label for="workflowDefinitionVersion">Workflow definition version</label>
                <select id="workflowDefinitionVersion" name="workflowDefinitionVersion" class="ui fluid search selection dropdown clearable">
                  <option value="">Latest revision</option>
                  ${tableNode.node.attrs.version ? `<option value="${tableNode.node.attrs.version}" class="addition" selected>Version ${tableNode.node.attrs.version}</option>` : ''}
                </select>
            </div>
            <div class="field required">
                <label for="workflowDefinitionTaskNames">Workflow definition task names</label>
                <select id="workflowDefinitionTaskNames" name="workflowDefinitionTaskNames" class="ui fluid search selection multiple dropdown" multiple="">
                  <option value="">Select workflow definition task names</option>
                  ${tableNode.node.attrs.tasks?.map(task => `<option value="${encode(task)}" class="addition" selected>${encode(task)}</option>`).join('\n')}
                </select>
            </div>
            <div class="field${tableNode.node.type === view.state.schema.nodes.table ? '' : ' required'}">
                <label for="filterJsonPath">JSONPath filter expressions</label>
                <input id="filterJsonPath" name="filterJsonPath" type="text" value="${encode(tableNode.node.attrs.filter)}">
                <div class="ui top pointing basic large label">Filter expressions are supported via the syntax <code>?(condition)</code>. The symbol <code>@</code> denotes the task input being filtered. See <a target="_blank" rel="noopener noreferrer" href="http://goessner.net/articles/JsonPath/">JSONPath</a> for more information about JSONPath.</div>
            </div>
            ${tableNode.node.type === view.state.schema.nodes.table ?
            `
            <div class="field">
                <label for="sort">Sort</label>
                <input id="sort" name="sort" type="text" value="${encode(tableNode.node.attrs.sort)}">
                <div class="ui top pointing basic large label">Sort the list of tasks by task input field name.</div>
            </div>
            <div class="inline fields">
              <div class="field">
                <div class="ui radio checkbox checked">
                  <input id="sortAsc" type="radio" name="desc"${tableNode.node.attrs.desc === '1' ? '' : ' checked=""'} value="" class="hidden">
                  <label for="sortAsc">Ascending</label>
                </div>
              </div>
              <div class="field">
                <div class="ui radio checkbox">
                  <input id="sortDesc" type="radio" name="desc"${tableNode.node.attrs.desc === '1' ? ' checked=""' : ''} value="1" class="hidden">
                  <label for="sortDesc">Descending</label>
                </div>
              </div>
            </div>
            ` : ''}
            <div class="field required">
                <label for="size">Limit</label>
                <select id="size" name="size" class="ui fluid selection dropdown">
                  <option value="5"${size === 5 ? ' selected' : ''}>5</option>
                  <option value="10"${size === 10 ? ' selected' : ''}>10</option>
                  <option value="25"${size === 25 ? ' selected' : ''}>25</option>
                  <option value="50"${size === 50 ? ' selected' : ''}>50</option>
                  <option value="100"${size === 100 ? ' selected' : ''}>100</option>
                </select>
                <div class="ui top pointing basic large label">Limit the numer of tasks to return per page.</div>
            </div>
            ${tableNode.node.type === view.state.schema.nodes.grid_column ?
            `
            <div class="field required">
                <label for="inputParameters">Apply input parameters</label>
                <p>Update the dragged in task input parameters with the following JSON payload.</p>
                <input type="hidden" id="inputParameters" name="inputParameters" value="${encode(stringifyJSON(tableNode.node.attrs.inputParameters || {}, null, 2))}">
            </div>
            ` : ''}
            <div class="ui wrapping spaced buttons">
              <button id="ok-workflow-${tableNode.pos}" class="ui tiny compact button primary">Ok</button>
              <button id="cancel-workflow-${tableNode.pos}" class="ui tiny compact button">Cancel</button>
              <button id="remove-workflow-${tableNode.pos}" class="ui tiny compact button">Remove</button>
            </div>
        </div>`,
        on: 'manual',
        position: 'bottom center',
        forcePosition: true,
        variation: 'fixed very wide',
        transition: 'scale',
        duration: 0,
        closable: false,
        onVisible: () => {
            $(document.getElementById('workflowDefinitionId')).dropdown({
                apiSettings: {
                    url: '/api/workflow-definitions?size=1000',
                    cache: false,
                    rawResponse: true,
                    onResponse: ({content: workflowDefinitions}) => ({
                        success: true,
                        results: workflowDefinitions.map(workflowDefinition => ({
                            value: workflowDefinition.id,
                            name: workflowDefinition.name,
                        }))
                    }),
                },
                onChange: workflowDefinitionId => {
                    refreshWorkflowDefinitionVersionsDropdown(workflowDefinitionId);
                    refreshWorkflowTaskNamesDropdown(workflowDefinitionId);
                },
                preserveHTML: false,
                filterRemoteData: true,
                saveRemoteData: false,
                duration: 0,
            });

            setWorkflowDefinitionDropdown(tableNode.node.attrs.id);
            refreshWorkflowDefinitionVersionsDropdown(tableNode.node.attrs.id, tableNode.node.attrs.version);
            refreshWorkflowTaskNamesDropdown(tableNode.node.attrs.id, tableNode.node.attrs.version, tableNode.node.attrs.tasks)

            if (document.getElementById('inputParameters')) {
                const value = decode(document.getElementById('inputParameters').value) || '';

                import(/* webpackChunkName: "code-editor" */ '../../Common/codeEditor')
                    .then(module => module.codeEditor({
                        callbackFn: editor => {
                            editor.on('blur', codeMirror => {
                                const inputParametersEl = document.getElementById('inputParameters');
                                const newValue = parseJSON(codeMirror.getValue());
                                if (!isEqual(parseJSON(inputParametersEl.value), newValue)) {
                                    inputParametersEl.value = encode(stringifyJSON(newValue));
                                }
                            });

                            const fieldElement = editor.getWrapperElement();
                            fieldElement.classList.add('ui', 'segment', 'basic', 'fitted');

                            document.getElementById('inputParameters').insertAdjacentElement('afterend', fieldElement);

                            editor.refresh();
                        },
                        options: {
                            lint: true,
                            mode: 'application/json',
                            value
                        }
                    }));
            }

            const fields = {
                filterJsonPath: {
                    optional: tableNode.node.type === view.state.schema.nodes.table,
                    rules: [
                        {
                            type: 'regExp[/^\\\?.+$/]',
                            prompt: '{name} must starts with ?'
                        }
                    ]
                },
                size: {
                    optional: false,
                    rules: [
                        {
                            type: 'regExp[/^(5|10|25|50|100)$/]',
                            prompt: 'Size must one of: 5, 10, 25, 50, 100'
                        }
                    ]
                }
            };

            if (tableNode.node.type === view.state.schema.nodes.grid_column) {
                fields.inputParameters = 'empty';
            }

            const form = $(`#workflow-form-${tableNode.pos}`).form({
                inline: true,
                autoCheckRequired: true,
                duration: 0,
                fields
            });

            document.getElementById(`ok-workflow-${tableNode.pos}`).addEventListener("click", e => {
                e.preventDefault();
                e.stopImmediatePropagation();
                form.form('validate form');
                if (!form.form('is valid')) {
                    return;
                }
                const state = view.state;

                const attrs = {
                    ...tableNode.node.attrs,
                    id: form.form('get value', 'workflowDefinitionId'),
                    version: form.form('get value', 'workflowDefinitionVersion'),
                    tasks: form.form('get value', 'workflowDefinitionTaskNames'),
                    filter: form.form('get value', 'filterJsonPath'),
                    size: form.form('get value', 'size')
                };

                if (tableNode.node.type === view.state.schema.nodes.grid_column) {
                    attrs.inputParameters = parseJSON(decode(form.form('get value', 'inputParameters')));
                } else if (tableNode.node.type === view.state.schema.nodes.table) {
                    attrs.sort = form.form('get value', 'sort');
                    attrs.desc = form.form('get value', 'desc');
                }

                let transaction = state.tr.setNodeMarkup(tableNode.pos, undefined, attrs);

                view.dispatch(transaction);
                view.focus();
            });

            const recreateMenu = () => {
                const el = document.getElementById('menu_table_task_list');
                if (el) {
                    $(el).popup('destroy');
                    addTooltip(el, 'Workflow task list');
                    if (!tableNode.node.attrs.id) {
                        el.classList.remove('active');
                    } else {
                        el.classList.add('active');
                    }
                }
            }

            document.getElementById(`cancel-workflow-${tableNode.pos}`).addEventListener("click", () => {
                recreateMenu();
                view.focus();
            });

            document.getElementById(`remove-workflow-${tableNode.pos}`).addEventListener("click", () => {
                const state = view.state;
                const transaction = state.tr.setNodeMarkup(tableNode.pos, undefined, {
                    ...tableNode.node.attrs,
                    id: null,
                    version: null,
                    tasks: null,
                    filter: null,
                    sort: null,
                    desc: null,
                    inputParameters: null
                });
                view.dispatch(transaction);
                recreateMenu();
                view.focus();
            });
        }
    }).popup('show');
}

const showColorsMenu = (view, type) => {
    $('#menu_link, #menu_table_task_list').popup('destroy');
    const {from, to} = view.state.selection;
    let extraCcolorLabels = [' ', `<a class="ui basic label circular" data-color="remove">Remove</a>`];
    let selectedColor;
    if (type === 'grid') {
        selectedColor = view.state.selection.node.attrs.color
    } else if (type === 'table') {
        if (view.state.selection instanceof CellSelection) {
            view.state.selection.forEachCell(cell => {
                selectedColor = cell.attrs.color;
            });
        }
    } else if (type === 'label') {
        const nodeAfter = view.state.doc.resolve(from).nodeAfter;
        const labelMark = nodeAfter.marks.find(mark => mark.type === view.state.schema.marks.label);
        selectedColor = labelMark?.attrs.color;
        extraCcolorLabels.unshift(`<a class="ui label empty circular${labelMark && selectedColor === '' ? ' selected' : ''}" data-color=""></a>`);
    } else if (type === 'button') {
        const link = findLink(view.state);
        selectedColor = link?.attrs?.color;
        extraCcolorLabels.unshift(`<a class="ui label empty primary circular${link && selectedColor === 'primary' ? ' selected' : ''}" data-color="primary"></a>`);
    }

    $(`#menu_${type}_color`).popup({
        html: [...colorLabels(selectedColor), ...extraCcolorLabels].join(''),
        on: 'manual',
        position: 'bottom center',
        forcePosition: true,
        transition: 'scale',
        duration: 0,
        closable: false,
        onVisible: () => {
            $('a.ui.circular.label', this).click(e => {
                const color = colors.includes(e.target.getAttribute('data-color')) ? e.target.getAttribute('data-color') : undefined;
                if (type === 'table') {
                    setCellAttr('color', color)(view.state, view.dispatch);
                } else if (type === 'label') {
                    if (color || e.target.getAttribute('data-color') === '') {
                        view.dispatch(view.state.tr.addMark(from, to,
                            view.state.schema.marks.label.create({
                                color
                            })));
                        view.dispatch(view.state.tr.removeMark(from, to, view.state.schema.marks.link));
                    } else {
                        view.dispatch(view.state.tr.removeMark(from, to, view.state.schema.marks.label));
                    }
                } else if (type === 'button') {
                    const link = findLink(view.state);
                    if (color || e.target.getAttribute('data-color') === 'primary' || e.target.getAttribute('data-color') === '') {
                        view.dispatch(view.state.tr.addMark(from, to,
                            view.state.schema.marks.link.create({
                                ...link.attrs,
                                color: color || e.target.getAttribute('data-color')
                            })));
                    } else {
                        view.dispatch(view.state.tr.addMark(from, to,
                            view.state.schema.marks.link.create({
                                ...link.attrs,
                                color: undefined
                            })));
                    }
                } else {
                    const state = view.state;
                    const transaction = state.tr.setNodeMarkup(state.selection.from, undefined, {
                        ...state.selection.node.attrs,
                        color: color || 'white',
                    });
                    view.dispatch(transaction);
                }
                view.focus();
            });
        }
    }).popup('show');
}

class MenuTooltip {
    constructor(view) {
        this.update(view, null)
    }

    create(view) {
        let menu = document.getElementById('menu-tooltip');
        if (!menu) {
            menu = document.createElement("div");
            menu.id = "menu-tooltip";
            menu.className = 'ui popup top left basic transition hidden';

            this.createHeadingButtons(menu, view);
            this.createFormatButtons(menu, view);
            this.createImageButtons(menu, view);
            this.createListButtons(menu, view);
            this.createLayoutButtons(menu, view);
            this.createTableButtons(menu, view);
            this.createGridButtons(menu, view);
        }
        return menu;
    }

    update(view, lastState) {
        if (lastState && lastState.doc.eq(view.state.doc) && lastState.selection.eq(view.state.selection)) {
            return;
        }

        closeMenuToolTip();

        if (!view.editable) {
            return;
        }

        const codeOrMathSelected = isNodeTypesSelected([
            view.state.schema.nodes.code_block,
            view.state.schema.nodes.math_inline,
            view.state.schema.nodes.math_block,
        ], view.state.selection);
        const isImageSelected = isImage(view.state);
        const isTableSelected = isInTableSelection(view.state.selection);
        const isGridColumnSelected = isInGridColumn(view.state);
        const isTextSelected = isText(view.state);
        if (!codeOrMathSelected && (isTextSelected || isImageSelected || isTableSelected || isGridColumnSelected)) {
            const $pos = view.state.doc.resolve(view.state.selection.from);
            const nodeAfter = $pos.nodeAfter;

            if (isTableSelected || isGridColumnSelected || (nodeAfter && [view.state.schema.nodes.text, view.state.schema.nodes.image].includes(nodeAfter.type))) {
                const menu = this.create(view);
                view.dom.parentNode.appendChild(menu);

                const {from, to} = view.state.selection;
                const start = view.coordsAtPos(from);
                const end = view.coordsAtPos(to);
                const {
                    left: boxLeft,
                    width: boxWidth,
                    bottom: boxBottom
                } = view.dom.offsetParent.getBoundingClientRect();
                const {width: menuWidth} = menu.getBoundingClientRect();

                let selectionTop = start.top;
                if (isImageSelected) {
                    selectionTop = view.nodeDOM(view.state.selection.$anchor.pos).getBoundingClientRect().top;
                }

                let menuPosition = start.left;
                if (isTextSelected || isImageSelected) {
                    menuPosition = Math.max((start.left + end.left) / 2,
                        start.left);
                }

                if (selectionTop === 0 && view.domAtPos(from)) {
                    const {node: element} = view.domAtPos(from);
                    if (element && typeof element.getBoundingClientRect === 'function') {
                        selectionTop = element.getBoundingClientRect().top;
                        menuPosition = end.left;
                    }
                }

                menu.style.left = Math.max(Math.min(menuPosition - boxLeft, boxWidth - menuWidth), 0) + "px";
                menu.style.bottom = (boxBottom - selectionTop) + "px";

                $(menu).transition({
                    animation: 'scale',
                    duration: 0,
                    onShow: () => this.activateCurrentButtons(view)
                });
            }
        }
    }

    activateCurrentButtons(view) {
        const {from} = view.state.selection;
        const $pos = view.state.doc.resolve(from);
        const isTableSelection = isInTableSelection(view.state.selection);
        const isGridColumnSelected = isInGridColumn(view.state);
        const cellColors = new Set();
        let nodeType;

        for (let d = $pos.depth; d > 0; d--) {
            const node = $pos.node(d);
            let name = `menu_${node.type.name}`;
            if (node.type === view.state.schema.nodes.heading) {
                name = `${name}_${node.attrs.level}`;
            } else if (isImage(view.state)) {
                name = `menu_image_${view.state.selection.node.attrs.width}`;
            } else if (isTableSelection) {
                nodeType = 'table';
                const cellAlignments = new Set();
                view.state.selection.forEachCell(cell => {
                    cellAlignments.add(cell.attrs['data-aligned']);

                    const cellColor = colors.find(color => cell.attrs.color?.includes(color));
                    if (cellColor) {
                        cellColors.add(cellColor);
                    }
                });
                if (cellAlignments.size === 1) {
                    const button = document.getElementById(`menu_table_align_${[...cellAlignments][0]}`);
                    button && button.classList.add('active');
                }
                break;
            } else if (isGridColumnSelected) {
                nodeType = 'grid';
                if (view.state.selection.node.attrs.color) {
                    const cellColor = colors.find(color => view.state.selection.node.attrs.color?.includes(color));
                    if (cellColor) {
                        cellColors.add(cellColor);
                    }
                }
                if (view.state.selection.node.attrs['data-aligned']) {
                    const button = document.getElementById(
                        `menu_grid_align_${view.state.selection.node.attrs['data-aligned']}`);
                    button && button.classList.add('active');
                }
                break;
            }

            const button = document.getElementById(name);
            if (button) {
                button.classList.add('active');
                break;
            }
        }

        if (nodeType && cellColors.size >= 1) {
            const button = document.getElementById(`menu_${nodeType}_color`);
            button && button.classList.add('active');
        }

        const nodeAfter = $pos.nodeAfter;
        if (nodeAfter) {
            nodeAfter.marks.forEach(mark => {
                let name = `menu_${mark.type.name}`;
                if (mark.type === view.state.schema.marks.label) {
                    name = `menu_${mark.type.name}_color`;
                }

                document.getElementById(name)?.classList.add('active');

                if (mark.type === view.state.schema.marks.link && mark.attrs.button && mark.attrs.color) {
                    document.getElementById('menu_button_color')?.classList.add('active');
                }
            });
        }
    }

    createLayoutButtons(container, view) {
        if (!isInList(view.state)) {
            return;
        }

        const layoutGroup = document.createElement('div');
        layoutGroup.className = 'ui mini buttons';
        layoutGroup.appendChild(this.createButton('menu_outdent', FormatIndentDecreaseSvg, () => {
            view.focus();
            chainCommands(liftListItem(view.state.schema.nodes.checkbox_item), liftListItem(view.state.schema.nodes.list_item))(view.state, view.dispatch);
        }, 'Decrease indent'));
        layoutGroup.appendChild(this.createButton('menu_indent', FormatIndentIncreaseSvg, () => {
            view.focus();
            chainCommands(sinkListItem(view.state.schema.nodes.checkbox_item), sinkListItem(view.state.schema.nodes.list_item))(view.state, view.dispatch);
        }, 'Increase indent'));

        if (layoutGroup.hasChildNodes()) {
            if (container.hasChildNodes()) {
                container.appendChild(document.createTextNode('\u00A0'));
            }
            container.appendChild(layoutGroup);
        }
    }

    createTableButtons(container, view) {
        const colIndex = getColumnIndex(view.state.selection);
        const rowIndex = getRowIndex(view.state.selection);
        const isTableSelection = colIndex !== undefined && rowIndex !== undefined;

        const tableGroup = document.createElement('div');
        tableGroup.className = 'ui mini buttons';

        if (view.state.selection instanceof CellSelection) {
            const tableFormatGroup = document.createElement('div');
            tableFormatGroup.className = 'ui mini buttons';
            tableFormatGroup.appendChild(this.createButton('menu_table_align_left', FormatAlignLeftSvg, () => {
                view.focus();
                setCellAttr('aligned', 'left')(view.state, view.dispatch);
            }, 'Left align'));
            tableFormatGroup.appendChild(this.createButton('menu_table_align_center', FormatAlignCenterSvg, () => {
                view.focus();
                setCellAttr('aligned', 'center')(view.state, view.dispatch);
            }, 'Center align'));
            tableFormatGroup.appendChild(this.createButton('menu_table_align_right', FormatAlignRightSvg, () => {
                view.focus();
                setCellAttr('aligned', 'right')(view.state, view.dispatch);
            }, 'Right align'));
            if (container.hasChildNodes()) {
                container.appendChild(document.createTextNode('\u00A0'));
            }
            container.appendChild(tableFormatGroup);

            const cellColSpans = [];
            const cellRowSpans = []
            view.state.selection.forEachCell(cell => {
                cellColSpans.push(cell.attrs.colspan);
                cellRowSpans.push(cell.attrs.rowspan);
            });
            if (cellColSpans.every(cellColSpan => cellColSpan > 1) || cellRowSpans.every(cellRowSpan => cellRowSpan > 1)) {
                tableGroup.appendChild(this.createButton('menu_table_split_cell', TableSplitCellSvg, () => {
                    view.focus();
                    splitCell(view.state, view.dispatch);
                }, 'Split cell'));
            } else if (view.state.selection.ranges.length > 1) {
                tableGroup.appendChild(this.createButton('menu_table_merge_cells', TableMergeCellsSvg, () => {
                    view.focus();
                    mergeCells(view.state, view.dispatch);
                }, 'Merge cells'));
            }

            tableGroup.appendChild(this.createButton('menu_table_color', FormatColorFillSvg, () => {
                document.getElementById('menu_table_color').classList.add('active');
                showColorsMenu(view, 'table');
            }, 'Table color'));
        }

        if (isTableSelection) {
            if (view.state.schema.nodes.page_title) {
                const tableTaskListButton = this.createButton('menu_table_task_list',
                    DatabaseSvg, () => {
                        view.focus();
                        showTaskListMenu(view);
                    }, 'Workflow task list');
                const tableNode = findTable(view.state.selection);
                if (isTaskList(tableNode)) {
                    tableTaskListButton.classList.add('active');
                }
                tableGroup.appendChild(tableTaskListButton);
            }

            tableGroup.appendChild(this.createButton('menu_table_add_column_before', TableColumnPlusBeforeSvg, () => {
                view.focus();
                addColumnBefore(view.state, view.dispatch);
            }, 'Insert column left'));
            tableGroup.appendChild(this.createButton('menu_table_add_column_after', TableColumnPlusAfterSvg, () => {
                view.focus();
                addColumnAfter(view.state, view.dispatch);
            }, 'Insert column right'));
            tableGroup.appendChild(this.createButton('menu_table_add_row_before', TableRowPlusBeforeSvg, () => {
                view.focus();
                addRowBefore(view.state, view.dispatch);
            }, 'Insert row above'));
            tableGroup.appendChild(this.createButton('menu_table_add_row_after', TableRowPlusAfterSvg, () => {
                view.focus();
                addRowAfter(view.state, view.dispatch);
            }, 'Insert row below'));
            tableGroup.appendChild(this.createButton('menu_table_delete', TableRemoveSvg, () => {
                view.focus();
                deleteTable(view.state, view.dispatch);
            }, 'Delete table'));
        } else if (colIndex !== undefined) {
            const headerColumnButton = this.createButton('menu_table_header_column', TableColumnSvg, () => {
                view.focus();
                toggleHeaderColumn(view.state, view.dispatch);
            }, 'Header column');
            const cellTypes = []
            view.state.selection.forEachCell(cell => cellTypes.push(cell.type));
            if (cellTypes.every(type => type === view.state.schema.nodes.table_header)) {
                headerColumnButton.classList.add('active');
            }
            tableGroup.appendChild(headerColumnButton);
            tableGroup.appendChild(this.createButton('menu_table_add_column_before', TableColumnPlusBeforeSvg, () => {
                view.focus();
                addColumnBefore(view.state, view.dispatch);
            }, 'Insert column left'));
            tableGroup.appendChild(this.createButton('menu_table_add_column_after', TableColumnPlusAfterSvg, () => {
                view.focus();
                addColumnAfter(view.state, view.dispatch);
            }, 'Insert column right'));
            tableGroup.appendChild(this.createButton('menu_table_delete_column', TableColumnRemoveSvg, () => {
                view.focus();
                chainCommands(deleteColumn, deleteTable)(view.state, view.dispatch);
            }, 'Delete column'));
        } else if (rowIndex !== undefined) {
            const headerRowButton = this.createButton('menu_table_header_row', TableRowSvg, () => {
                view.focus();
                toggleHeaderRow(view.state, view.dispatch);
            }, 'Header row');
            const cellTypes = []
            view.state.selection.forEachCell(cell => cellTypes.push(cell.type));
            if (cellTypes.every(type => type === view.state.schema.nodes.table_header)) {
                headerRowButton.classList.add('active');
            }
            tableGroup.appendChild(headerRowButton);
            tableGroup.appendChild(this.createButton('menu_table_add_row_before', TableRowPlusBeforeSvg, () => {
                view.focus();
                addRowBefore(view.state, view.dispatch);
            }, 'Insert row above'));
            tableGroup.appendChild(this.createButton('menu_table_add_row_after', TableRowPlusAfterSvg, () => {
                view.focus();
                addRowAfter(view.state, view.dispatch);
            }, 'Insert row below'));
            tableGroup.appendChild(this.createButton('menu_table_delete_row', TableRowRemoveSvg, () => {
                view.focus();
                chainCommands(deleteRow, deleteTable)(view.state, view.dispatch);
            }, 'Delete row'));
        }

        if (tableGroup.hasChildNodes()) {
            if (container.hasChildNodes()) {
                container.appendChild(document.createTextNode('\u00A0'));
            }
            container.appendChild(tableGroup);
        }
    }

    createGridButtons(container, view) {
        const isGridColumnSelected = isInGridColumn(view.state);
        if (!isGridColumnSelected) {
            return;
        }

        const gridGroup = document.createElement('div');
        gridGroup.className = 'ui mini buttons';

        const gridFormatGroup = document.createElement('div');
        gridFormatGroup.className = 'ui mini buttons';

        gridFormatGroup.appendChild(
            this.createButton('menu_grid_align_left', FormatAlignLeftSvg, () => {
                view.focus();
                const state = view.state;
                const transaction = state.tr.setNodeMarkup(state.selection.from, undefined, {
                    ...state.selection.node.attrs,
                    aligned: 'left'
                });
                view.dispatch(transaction);
            }, 'Left align'));
        gridFormatGroup.appendChild(
            this.createButton('menu_grid_align_center', FormatAlignCenterSvg,
                () => {
                    view.focus();
                    const state = view.state;
                    const transaction = state.tr.setNodeMarkup(state.selection.from, undefined, {
                        ...state.selection.node.attrs,
                        aligned: 'center'
                    });
                    view.dispatch(transaction);
                }, 'Center align'));
        gridFormatGroup.appendChild(
            this.createButton('menu_grid_align_right', FormatAlignRightSvg,
                () => {
                    view.focus();
                    const state = view.state;
                    const transaction = state.tr.setNodeMarkup(state.selection.from, undefined, {
                        ...state.selection.node.attrs,
                        aligned: 'right'
                    });
                    view.dispatch(transaction);
                }, 'Right align'));
        if (container.hasChildNodes()) {
            container.appendChild(document.createTextNode('\u00A0'));
        }
        container.appendChild(gridFormatGroup);

        gridGroup.appendChild(
            this.createButton('menu_grid_color', FormatColorFillSvg, () => {
                document.getElementById('menu_grid_color').classList.add('active');
                showColorsMenu(view, 'grid');
            }, 'Grid color')
        );

        if (view.state.schema.nodes.page_title) {
            const column = findColumn(view.state);
            const gridTaskListButton = this.createButton('menu_table_task_list',
                DatabaseSvg, () => {
                    view.focus();
                    showTaskListMenu(view);
                }, 'Workflow task list');

            if (isTaskList(column?.node)) {
                gridTaskListButton.classList.add('active');
            }
            gridGroup.appendChild(gridTaskListButton);
        }

        gridGroup.appendChild(this.createButton('menu_grid_add_column_before',
            TableColumnPlusBeforeSvg, () => {
                view.focus();
                const state = view.state;
                const transaction = state.tr.insert(state.selection.$anchor.pos, state.schema.nodes.grid_column.createAndFill({width: 8}));
                view.dispatch(transaction);
            }, 'Insert grid column left'));
        gridGroup.appendChild(this.createButton('menu_grid_add_column_after',
            TableColumnPlusAfterSvg, () => {
                view.focus();
                const state = view.state;
                const transaction = state.tr.insert(state.selection.$head.pos, state.schema.nodes.grid_column.createAndFill({width: 8}));
                view.dispatch(transaction);
            }, 'Insert grid column right'));
        gridGroup.appendChild(
            this.createButton('menu_grid_delete_column', TableColumnRemoveSvg,
                () => {
                    view.focus();
                    deleteSelection(view.state, view.dispatch);
                }, 'Delete grid column'));

        if (gridGroup.hasChildNodes()) {
            if (container.hasChildNodes()) {
                container.appendChild(document.createTextNode('\u00A0'));
            }
            container.appendChild(gridGroup);
        }
    }

    createListButtons(container, view) {
        if (isInPageTitle(view.state)
            || isImage(view.state)
            || isLink(view.state)
            || isInHeading(view.state)
            || isInTableSelection(view.state.selection)
            || isInGridColumn(view.state)
            || isInFormLabel(view.state)) {
            return;
        }

        const listGroup = document.createElement('div');
        listGroup.className = 'ui mini buttons';
        if (!isInCheckList(view.state) && !isInCardHeading(view.state)) {
            listGroup.appendChild(this.createButton('menu_bullet_list', FormatListBulletedSvg, () => {
                view.focus();
                toggleList(view.state.schema.nodes.bullet_list, view.state.schema.nodes.list_item)(view.state, view.dispatch);
            }, 'Bulleted list'));
            listGroup.appendChild(this.createButton('menu_ordered_list', FormatListNumberedSvg, () => {
                view.focus();
                toggleList(view.state.schema.nodes.ordered_list, view.state.schema.nodes.list_item)(view.state, view.dispatch);
            }, 'Numbered list'));
        }

        if (!isInBulletOrOrderedList(view.state) && !isInCardHeading(view.state)) {
            listGroup.appendChild(this.createButton('menu_checkbox_list', FormatListChecksSvg, () => {
                view.focus();
                toggleList(view.state.schema.nodes.checkbox_list, view.state.schema.nodes.checkbox_item)(view.state, view.dispatch);
            }, 'To-do list'));
        }

        if (listGroup.hasChildNodes()) {
            if (container.hasChildNodes()) {
                container.appendChild(document.createTextNode('\u00A0'));
            }
            container.appendChild(listGroup);
        }
    }

    createHeadingButtons(container, view) {
        if (isInPageTitle(view.state)
            || isInList(view.state)
            || isImage(view.state)
            || isInTableSelection(view.state.selection)
            || isInGridColumn(view.state)
            || isInFormLabel(view.state)
            || (isInCardContent(view.state) && !isInCardHeading(view.state))) {
            return;
        }

        const headingGroup = document.createElement('div');
        headingGroup.className = 'ui mini buttons';
        headingGroup.appendChild(this.createButton('menu_heading_1', FormatHeader1Svg, () => {
            view.focus();
            toggleBlockType(view.state.schema.nodes.heading, view.state.schema.nodes.paragraph, {level: 1})(view.state, view.dispatch);
        }, 'Heading 1'));
        headingGroup.appendChild(this.createButton('menu_heading_2', FormatHeader2Svg, () => {
            view.focus();
            toggleBlockType(view.state.schema.nodes.heading, view.state.schema.nodes.paragraph, {level: 2})(view.state, view.dispatch);
        }, 'Heading 2'));
        headingGroup.appendChild(this.createButton('menu_heading_3', FormatHeader3Svg, () => {
            view.focus();
            toggleBlockType(view.state.schema.nodes.heading, view.state.schema.nodes.paragraph, {level: 3})(view.state, view.dispatch);
        }, 'Heading 3'));
        container.appendChild(headingGroup);
    }

    createFormatButtons(container, view) {
        if (isInFormLabel(view.state)) {
            return;
        }

        const isImageSelected = isImage(view.state);
        const inTableSelection = isInTableSelection(view.state.selection);
        const isGridColumnSelected = isInGridColumn(view.state)

        const formatGroup = document.createElement('div');
        formatGroup.className = 'ui mini buttons';
        if (!isImageSelected) {
            formatGroup.appendChild(this.createButton('menu_strong', FormatBoldSvg, () => {
                view.focus();
                toggleMark(view.state.schema.marks.strong)(view.state, view.dispatch);
            }, 'Bold'));
            formatGroup.appendChild(this.createButton('menu_em', FormatItalicSvg, () => {
                view.focus();
                toggleMark(view.state.schema.marks.em)(view.state, view.dispatch);
            }, 'Italic'));
            formatGroup.appendChild(this.createButton('menu_strikethrough', FormatStrikethroughSvg, () => {
                view.focus();
                toggleMark(view.state.schema.marks.strikethrough)(view.state, view.dispatch);
            }, 'Strike-through'));
            formatGroup.appendChild(this.createButton('menu_underline', FormatUnderlineSvg, () => {
                view.focus();
                toggleMark(view.state.schema.marks.underline)(view.state, view.dispatch);
            }, 'Underline'));
            formatGroup.appendChild(this.createButton('menu_mark', FormatColorHighlightSvg, () => {
                view.focus();
                toggleMark(view.state.schema.marks.mark)(view.state, view.dispatch);
            }, 'Highlight'));

            const link = findLink(view.state);
            if (link?.attrs?.button) {
                formatGroup.appendChild(
                    this.createButton('menu_button_color', FormatColorFillSvg, () => {
                        document.getElementById('menu_button_color').classList.add('active');
                        view.focus();
                        showColorsMenu(view, 'button');
                    }, 'Color'));
            } else {
                formatGroup.appendChild(
                    this.createButton('menu_label_color', LabelSvg, () => {
                        document.getElementById('menu_label_color').classList.add('active');
                        view.focus();
                        showColorsMenu(view, 'label');
                    }, 'Label'));
            }
        }

        if (!isCellSelection(view.state.selection)) {
            formatGroup.appendChild(this.createButton('menu_link', LinkSvg, () => {
                document.getElementById('menu_link').classList.add('active');
                view.focus();
                showLinkMenu(view);
            }, 'Insert link'));
        }

        if (!isImageSelected) {
            formatGroup.appendChild(this.createButton('menu_code', CodeTagsSvg, () => {
                view.focus();
                toggleMark(view.state.schema.marks.code)(view.state, view.dispatch);
            }, 'Mark as code'));

            if (!isInPageTitle(view.state)
                && !isImageSelected
                && !isInHeading(view.state)
                && !isInFormLabel(view.state)) {
                formatGroup.appendChild(
                    this.createButton('menu_math_inline', SquareRootSvg, () => {
                        view.focus();
                        const selectionText = view.state.doc.cut(
                            view.state.selection.from,
                            view.state.selection.to
                        ).textContent;
                        if (!isEmpty(selectionText)) {
                            const tr = view.state.tr.replaceSelectionWith(
                                view.state.schema.nodes.math_inline.createAndFill({},
                                    view.state.schema.text(
                                        selectionText))).scrollIntoView();
                            view.dispatch(tr);
                        }
                    }, 'Create equation'));
            }

            const selectionText = view.state.doc.cut(
                view.state.selection.from,
                view.state.selection.to
            ).textContent;
            const findRelativeTimeMark = findRelativeTime(view.state);
            if ((selectionText?.startsWith('${') && selectionText?.endsWith('}') || !isNaN(Date.parse(selectionText)) || findRelativeTimeMark)) {
                formatGroup.appendChild(this.createButton('menu_relative_time', CalendarClockOutlinesSvg, () => {
                    document.getElementById('menu_relative_time').classList.add('active');
                    view.focus();
                    showRelativeTimeMenu(view);
                }, 'Relative time for ISO 8601 timestamp'));
            }
        }

        if (!isInPageTitle(view.state)
            && !isInList(view.state)
            && !isImageSelected
            && !isInHeading(view.state)
            && !inTableSelection
            && !isGridColumnSelected
            && !isInFormLabel(view.state)
            && !isInCard(view.state)) {
            formatGroup.appendChild(this.createButton('menu_blockquote', CommentQuoteOutlineSvg, () => {
                view.focus();
                wrapIn(view.state.schema.nodes.blockquote)(view.state, view.dispatch);
            }, 'Quote'));
        }

        if (formatGroup.hasChildNodes()) {
            if (container.hasChildNodes()) {
                container.appendChild(document.createTextNode('\u00A0'));
            }
            container.appendChild(formatGroup);
        }
    }

    createImageButtons(container, view) {
        const isImageSelected = isImage(view.state);

        if (!isImageSelected) {
            return;
        }

        const state = view.state;
        const image = document.createElement("img")
        image.src = state.selection.node.attrs.src;
        const {left, right} = view.dom.getBoundingClientRect();
        const imageWidth = image.naturalWidth;
        const imageHeight = image.naturalHeight;

        const smallSize = mediaSizeFit(imageWidth, imageHeight, Math.round((right - left - 10) / 3), imageHeight);
        const mediumSize = mediaSizeFit(imageWidth, imageHeight, Math.round((right - left - 10) / 2), imageHeight);
        const largeSize = mediaSizeFit(imageWidth, imageHeight, right - left, imageHeight);

        const imageGroup = document.createElement('div');
        imageGroup.className = 'ui mini buttons';

        if (state.selection.node.attrs['data-diagram']) {
            imageGroup.appendChild(this.createButton(`menu_image_edit`, ImageEditOutlineSvg, () => {
                const {node: element} = view.domAtPos(state.selection.from);
                const imageEl = element?.querySelector('img')
                if (imageEl) {
                    DiagramEditor.editElement(imageEl, view);
                }
            }, 'Edit draw.io diagram'));
        }

        imageGroup.appendChild(this.createButton(`menu_image_${smallSize.width}`, SizeSSvg, () => updateImageNodeSize(view, smallSize.width, smallSize.height), 'Small size'));
        imageGroup.appendChild(this.createButton(`menu_image_${mediumSize.width}`, SizeMSvg, () => updateImageNodeSize(view, mediumSize.width, mediumSize.height), 'Medium size'));
        imageGroup.appendChild(this.createButton(`menu_image_${largeSize.width}`, SizeLSvg, () => updateImageNodeSize(view, largeSize.width, largeSize.height), 'Large size'));
        imageGroup.appendChild(this.createButton(`menu_image_${imageWidth}`, ArrowExpandAllSvg, () => updateImageNodeSize(view, imageWidth, imageHeight), 'Actual size'));

        const {width, height} = view.state.selection.node.attrs;
        const imageDimension = document.createElement('span');
        imageDimension.className = 'ui tiny button disabled';
        imageDimension.textContent = `w: ${width || '?'}px, h: ${height || '?'}px`;
        imageGroup.appendChild(imageDimension);

        if (imageGroup.hasChildNodes()) {
            if (container.hasChildNodes()) {
                container.appendChild(document.createTextNode('\u00A0'));
            }
            container.appendChild(imageGroup);
        }
    }

    createButton(id, svgImage, clickListener, tooltip) {
        const button = document.createElement('button');
        button.id = id;
        button.className = 'ui button';

        button.insertAdjacentHTML('beforeend', `<img class="icon-18 ui" src="${svgImage}" alt="">`);
        button.addEventListener("click", e => {
            e.preventDefault();
            clickListener(e);
        });

        if (tooltip) {
            addTooltip(button, tooltip);
        }

        return button;
    }
}

const addTooltip = (el, tooltip) => {
    $(el).popup({
        position: 'top center',
        variation: 'mini',
        content: tooltip,
        transition: 'scale',
        duration: 0,
        addTouchEvents: false
    });
}

export const menuTooltip = new Plugin({
    view: (editorView) => new MenuTooltip(editorView),
    props: {
        handleDOMEvents: {
            dragstart: (view, event) => {
                if (!view.editable) {
                    return false;
                }

                closeMenuToolTip();
            },
        }
    }
});